const productAccordions = document.querySelectorAll('.product__accordion');

if (productAccordions.length) {
  const firstAccordion = productAccordions[0];
  const parent = firstAccordion.closest('.product__info-first-accordion-expanded-mobile');
  if (parent) {
    firstAccordion.classList.add('first');
    const details = firstAccordion.querySelector('details');
    if (details) details.setAttribute('open', '');
  } else {
    if (window.innerWidth >= 769) {
      firstAccordion.classList.add('first');
      const details = firstAccordion.querySelector('details');
      if (details) details.setAttribute('open', '');
    }
  }
}
